<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="formData.tanggal_awal"
          type="date"
          label="Dari Tanggal"
          outlined
          clearable
          dense
          autofocus
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="formData.tanggal_akhir"
          type="date"
          label="Sampai Tanggal"
          outlined
          clearable
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn color="primary" @click="fetchLaporan" :disabled="!formData.tanggal_awal || !formData.tanggal_akhir">
          Cari
        </v-btn>
      </v-col>
    </v-row>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">LAPORAN PENAGIHAN HARIAN PER COLLECTOR</h2>
        </div>
      </div>

      <div class="mt-4">
        <div v-for="el in data" :key="el.id" class="mb-4">
          <h2>Kolektor: {{ el.info.nama }}</h2>

          <table width="100%">
            <thead>
              <th>No Nota</th>
              <th>Kubikasi</th>
              <th>Tonase</th>
              <th>Biaya Tambahan</th>
              <th>Total Invoice</th>
            </thead>
            <tbody>
              <tr v-for="item in el.items" :key="item.id">
                <td class="text-center">{{ item.nota.nomor_nota }}</td>
                <td class="text-center">
                  {{ total_kubikasi(item.nota.invoice_detil) }}
                </td>
                <td class="text-center">
                  {{ total_tonase(item.nota.invoice_detil) }}
                </td>
                <td class="text-center">
                  {{ formatCurrency(item.nota.biaya_lain_total) }}
                </td>
                <td class="text-center">
                  {{ formatCurrency(item.nota.total) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal_awal: "",
        tanggal_akhir: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(`invoice/laporan-penagihan?tanggal_awal=${this.formData.tanggal_awal}&tanggal_akhir=${this.formData.tanggal_akhir}`)
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    total_kubikasi(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.m3;
        });
      });

      return total.toFixed(2);
    },
    total_tonase(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.ton;
        });
      });

      return total.toFixed(2);
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}
</style>
